import script from "./error-layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./error-layout.vue?vue&type=script&setup=true&lang=ts"

import "./error-layout.vue?vue&type=style&index=0&id=0c2fee02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c2fee02"]])

export default __exports__